import React from 'react';
import styles from './category-selector.module.scss';
import { Button } from 'components/base';
import { getWindowScrollPosition } from 'services/get-scroll-pos';
import { setScrollPosHomePage } from 'store-modules/app-settings';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Conversation } from '_types';

interface Props {
    categories: Conversation[];
    numberOfCategories?: number;
}

const CategorySelector: React.FC<Props> = ({
    categories,
    numberOfCategories = 4,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClick = (category: string) => {
        dispatch(setScrollPosHomePage(getWindowScrollPosition(window)));
        navigate(`browse/${category}`);
    };

    return (
        <div className={styles.container}>
            <div className={styles.buttonGroup}>
                {categories.slice(0, numberOfCategories).map((category) => (
                    <Button
                        key={category.id}
                        onClick={() => handleClick(category.slug)}
                        className={styles.categoryButton}
                    >
                        {category.name}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default CategorySelector;
